import type { ICameraControls } from '../ModelViewer';
import { useScanReviewMarginMarkingViewContext } from './ScanReviewMarginMarkingView.hooks';
import { ScanReviewPanel } from './ScanReviewPanel';
import { ScanReviewPanelType } from './ScanReviewViewTypes';
import React from 'react';

export const ScanReviewMarginMarkingView: React.FC = props => {
    const ctx = useScanReviewMarginMarkingViewContext();
    const scene = ctx.scene;
    const callbackRef = React.useCallback(
        (controls: ICameraControls) => {
            ctx.viewManager.initializeViewState(controls, ScanReviewPanelType.Front);
        },
        [ctx.viewManager],
    );
    return (
        <ScanReviewPanel
            scene={scene.scene}
            initializeCameraControlsCallback={callbackRef}
            canvasRef={ctx.viewManager.canvasRef}
            cameraRef={ctx.viewManager.cameraRef}
        >
            {props.children}
        </ScanReviewPanel>
    );
};
